import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./common/print.css";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";
import ReactToPrint from "react-to-print";
//import { calculatePrice } from "../pricing/calculatePrice";
import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
//import ReportHeader from "./common/ReportHeader";
//import ReportFooter from "./common/ReportFooter";
import PageNo from "./common/PageNo";
import PrintSlide from "./common/PrintSlide";
//import SwissPriceTable from "./common/SwissPriceTable";
import { calculatePrice } from "../pricing/calculatePrice";
import UserInfo from "./cartec/UserInfo";
import CartecPriceTable from "./cartec/CartecPriceTable";
import CartecFooter from "./cartec/CartecFooter";
import CartecHeader from "./cartec/CartecHeader";
import CarSVG from "../carbodyparts/CarSvg";
import logo from "./cartec/logo.png";
//import CommonPriceTable from "./common/CommonPriceTable";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class CartecReport extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,
    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    imgTypeReport: true,
    swissTable: [],
    words: {},
    lang: ""
  };
  count = [];
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    if (!selectedFile) {
      this.props.history.push("/dashboard");
    }
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
  }

  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
    }
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      }

      //  console.table(response.data[0].resultTXT.scanresult);
    } else {
      this.props.history.push("/login");
    }
  };

  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    for (let i = 0; i < rowArray.length; i++) {
      // if (rowArray[i].Amount) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      //promises.push(url);
      promises.push(Axios.get(url));
      // }
    }

    const arrRes = await Axios.all(promises);
    //const res = await Axios.get("http://driveandscan.de/api_v2/GetPartDetails.php?vin=279639&partnerId=001-sandip&part="+row.part)

    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");

      // let gtt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //   if (val2 && parseInt(val2) > 25) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }

      // });
      // let ltt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //  if (val2 && parseInt(val2) < 26) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }
      //   //return val2;
      // });

      // return { part: result.data.part,count:val.length-1, lt25: ltt.filter( Boolean ).length, gt25: gtt.filter( Boolean ).length };

      val.map((r) => {
        let val2 = r.split(" ")[3];

        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });

      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
    console.table(ltgtdata);
    //return 5
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      //   let dd = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      //  let countRow = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");

    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  render() {
    //const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const { orderNumber } = this.state.order;

    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    //const dentInfo = scanResult.resultTXT;

    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    return (
      <>
        <div className="animated fadeIn cartech-report">
          <div xs="12" sm="12" className="p-2">
            <Card>
              <CardHeader>
                <ReactToPrint
                  trigger={() => {
                    document.title = localStorage.getItem("selectedFile");
                    return (
                      <button className="glass btn btn-lg btn-danger pull-right">
                        <i className="fa fa-print" />
                        &nbsp; {this.lang("Print PDF")}
                      </button>
                    );
                  }}
                  content={() => this.componentRef}
                />
                <small>
                  {" "}
                  VIN Number : {localStorage.getItem("selectedFile")}
                </small>
              </CardHeader>
            </Card>

            <div
              className="container"
              id="divIdToPrint"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
            >
              <div className="row page-break-top vertical-center">
                <div className="col-sm-12">
                  <Card>
                    <CartecHeader />
                    <CardBody className="p-0">
                      <div className="newFormatReport">
                        <div className="row w-100">
                          <UserInfo />
                          <CartecPriceTable
                            vinfolderList={this.state.swissTable}
                          />
                        </div>
                      </div>
                    </CardBody>
                    <CartecFooter />
                  </Card>
                </div>
              </div>

              <div className="row page-break-top vertical-center">
                <div className="col-sm-12">
                  <Card>
                    <CardBody className="p-0">
                      <div className="newFormatReport">
                        <CartecHeader />
                        <div className="container car-svg-main p-0">
                          <div className="row ">
                            <div className="col-sm-12 car-svg-heading">
                              <h3>
                                {this.lang("2D")}<span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center">
                              <CarSVG {...this.props} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <CartecFooter />
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div>
          <Card>
            <CardBody>
              <Link className="glass" to="/ReportFull">
                <button className="btn btn-danger btn-sm pull-right">
                  {" "}
                  <i className="fa fa-dot-circle-o"></i> {">>"}{" "}
                </button>
              </Link>
              <Link className="glass" to="/TabView">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {" "}
                  {"<<"} <i className="fa fa-dot-circle-o"></i>{" "}
                </button>
              </Link>
            </CardBody>
          </Card>
        </div> */}
      </>
    );
  }
}

//export default Colors;
